module.exports = __webpack_public_path__ + "static/img/douyin.69f5857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyin.jpg
// module id = OpN1
// module chunks = 27